import Vue from 'vue'
import Router from 'vue-router'

const home = () => import( /* webpackChunkName: "home" */ './views/home.vue');
const about = () => import( /* webpackChunkName: "about" */ './views/about.vue');
const about_section = () => import( /* webpackChunkName: "about_section" */ '@/components/about-page/about-section.vue');
const about_awards = () => import( /* webpackChunkName: "about_awards" */ '@/components/about-page/awards-section.vue');
const about_history = () => import( /* webpackChunkName: "about_history" */ '@/components/about-page/history-section.vue');
const about_companies = () => import( /* webpackChunkName: "about_companies" */ '@/components/about-page/companies-section.vue');
const about_vacancies = () => import( /* webpackChunkName: "about_vacancies" */ '@/components/about-page/vacancies-section.vue');

const answers = () => import( /* webpackChunkName: "answers" */ './views/answers.vue');
const answersOwners = () => import( /* webpackChunkName: "answersOwners" */ '@/components/answers-page/answers-owners.vue');
const answersCustomers = () => import( /* webpackChunkName: "answersCustomers" */ '@/components/answers-page/answers-customers.vue');

const contacts = () => import( /* webpackChunkName: "contacts" */ './views/contacts.vue');
const contactsSales = () => import( /* webpackChunkName: "contactsSales" */ '@/components/contacts-page/contacts-sales.vue');
const contactsService = () => import( /* webpackChunkName: "contactsService" */ '@/components/contacts-page/contacts-service.vue');

const paymentTypes = () => import( /* webpackChunkName: "paymentTypes" */ './views/payment-types.vue');
const paymentPlan = () => import( /* webpackChunkName: "paymentPlan" */ '@/components/payment-page/payment-plan.vue');
const paymentCalc = () => import( /* webpackChunkName: "paymentCalc" */ '@/components/payment-page/payment-calc.vue');

const commerce = () => import( /* webpackChunkName: "commerce" */ './views/commerce.vue');
const commerceCard =() => import( /* webpackChunkName: "commerce-card" */ '@/components/commerce-page/commerce-card.vue');
const flats = () => import( /* webpackChunkName: "flats" */ './views/flats.vue');
const flatsCard =() => import( /* webpackChunkName: "flats-card" */ '@/components/flats-page/flats-card.vue');
const news = () => import( /* webpackChunkName: "news" */ './views/news.vue');
const newsCard = () => import( /* webpackChunkName: "news-card" */ '@/components/news-page/news-card.vue');
const parking = () => import( /* webpackChunkName: "parking" */ './views/parking.vue');
const salesCard = () => import( /* webpackChunkName: "salesCardPage" */ '@/components/sales-card/sales-card.vue');
const sales = () => import( /* webpackChunkName: "sales" */ './views/sales.vue');

const favorite = () => import( /* webpackChunkName: "favorite" */ './views/favorite.vue');
const favoriteContainer = () => import( /* webpackChunkName: "favorite" */ '@/components/favorite-page/favorite-page-container.vue');

const dataPolicy = () => import( /* webpackChunkName: "data-policy" */ './views/data-policy.vue');
const hypothec = () => import( /* webpackChunkName: "hypothec" */ './views/hypothec.vue');
const storerooms = () => import( /* webpackChunkName: "storerooms" */ './views/storerooms.vue');
const notfound = () => import( /* webpackChunkName: "notfound" */ './views/404.vue');

Vue.use(Router)

const router = new Router({
	mode: 'history',
	hash: false,
	scrollBehavior (to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			if (to.hash) {
				// console.log(to.hash, 'adasdasd')
				return resolve({ 
					selector: to.hash,
					offset: { x: 0, y: 75 }
				});
			} else if (savedPosition) {
				return resolve(savedPosition);
			} else {
				resolve(document.getElementById("app").scrollIntoView({ behavior: "instant" }));
			} 
		});
	},
	routes: [
		{
			path: '/',
			name: 'home',
			component: home,
		},
		{
			path: '/about',
			name: 'about',
			component: about,
			children: [
				{ 
					path: '/about', 
					name: 'about-page-about-us',
					component: about_section,
				},
				{ 
					path: '/about/awards', 
					name: 'about-page-awards',
					component: about_awards,
				},
				{ 
					path: '/about/history', 
					name: 'about-page-history',
					component: about_history,
				},
				{ 
					path: '/about/companies', 
					name: 'about-page-companies',
					component: about_companies,
				},
				{ 
					path: '/about/vacancies', 
					name: 'about-page-vacancies',
					component: about_vacancies,
				},
			]
		},
		// {
		// 	path: '/questions-answers',
		// 	name: 'answers',
		// 	component: answers,
		// 	children: [
		// 		{ 
		// 			path: '/questions-answers', 
		// 			name: 'answers-customers',
		// 			component: answersCustomers,
		// 		},
		// 		{ 
		// 			path: '/questions-answers/owners', 
		// 			name: 'answers-owners',
		// 			component: answersOwners,
		// 		}
		// 	]
		// },
		{
			path: '/news',
			name: 'news',
			component: news,
		},
		{
			path: '/news/:id',
			name: 'news-card',
			component: newsCard,
		},
		{
			path: '/commerce',
			name: 'commerce',
			component: commerce,
		},
		{
			path: '/commerce/:id',
			name: 'commerce-card',
			component: commerceCard,
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: contacts,
			children: [
				{ 
					path: '/contacts', 
					name: 'contacts-sales',
					component: contactsSales,
				},
				{ 
					path: '/contacts/service', 
					name: 'contacts-service',
					component: contactsService,
				}
			]
		},
		{
			path: '/favorite',
			name: 'favorite',
			component: favorite,
			redirect: { name: 'favoriteSales' },
			children: [
				{ 
					path: '/favorite', 
					name: 'favoriteSales',
					component: favoriteContainer,
				},
				{ 
					path: '/favorite/flats', 
					name: 'favoriteFlats',
					component: favoriteContainer,
				},
				{ 
					path: '/favorite/commerce', 
					name: 'favoriteCommerce',
					component: favoriteContainer,
				},
				{ 
					path: '/favorite/storerooms', 
					name: 'favoriteStoreRooms',
					component: favoriteContainer,
				},
				{ 
					path: '/favorite/parking', 
					name: 'favoriteParking',
					component: favoriteContainer,
				},
			]
		},
		{
			path: '/flats',
			name: 'flats',
			component: flats,
		},
		{
			path: '/flats/:id',
			name: 'flats-card',
			component: flatsCard,
		},
		{
			path: '/hypothec',
			name: 'hypothec',
			component: hypothec,
		},
		{
			path: '/parking',
			name: 'parking',
			component: parking,
		},
		{
			path: '/payment-types',
			name: 'payment-types',
			component: paymentTypes,
			children: [
				{ 
					path: '/payment-types', 
					name: 'payment-types-plan',
					component: paymentPlan,
				},
				{ 
					path: '/payment-types/hypothec-calculator', 
					name: 'payment-types-calculator',
					component: paymentCalc,
				}
			]
		},
		{
			path: '/sales',
			name: 'sales',
			component: sales,
		},
		{
			path: '/sales/:id',
			name: 'sales-card',
			component: salesCard,
		},
		{
			path: '/storerooms',
			name: 'storerooms',
			component: storerooms,
		},
		{
			path: '/data-policy',
			name: 'data-policy',
			component: dataPolicy,
		},
		{ 
            path: '/search', 
            name: 'search', 
            component: notfound, 
        }, 
		{ 
            path: '/404', 
            name: '404', 
            component: notfound, 
        }, 
        { 
            path: '*', 
            redirect: '/404'
		},
		{ 
            path: '/error', 
            name: 'error', 
            // component: error, 
		},
	]
})

// router.beforeResolve((to, from, next) => {
// //   if (to.name) {
// 	// console.log(to.name)
// 	// Счетчик избранных карточек из LocalStorage
// 	// var items = localStorage.getItem('favorite_projects');
// 	// items = items ? items.split(',') : [];
// 	// store.commit('setFavoriteCount', items.length);
// 	// Закрываем мобильное меню
// 	// store.commit('Open_Sendwich', false);
// 	// document.getElementsByTagName('body')[0].classList.remove('overlay-open');
// 	// Конец счетчика изюранных карточек
// 	// if (to.meta.template != 'sale-card') {
// 	// 	store.commit('resetSaleCardContent', null);
// 	// }
// //   }
//   next();
// })

export default router
